import { Actor, ComponentType } from "../core/actor.ts";
import { Stage } from "../core/stage.ts";

export class ActorMaterial {
  material: MaterialBase;
  materialType: ComponentType;

  constructor(material: MaterialBase) {
    this.materialType = Stage.getComponentType(material);
    this.material = material;
  }
}

let NextMaterialId = 1;

export class MaterialBase {
  id: number = NextMaterialId++;

  addToActor(actor: Actor) {
    // Only one "primary" material allowed at a time.
    let actorMaterial = actor.get(ActorMaterial);
    if (actorMaterial) {
      actor.remove(actorMaterial.materialType);
    }
    actor.add(new ActorMaterial(this));
  }

  removedFromActor(actor: Actor) {
    actor.remove(ActorMaterial);
  }
}